import axios from 'axios';

const CryptoJS = require('crypto-js');

const API_URL = process.env.REACT_APP_BASEURL;
let cipher = '';
const encryptKey = async () => {
    await axios.get(`${API_URL}Home/GetDate`).then((response) => {
        const apiKey = response.data;
        cipher = CryptoJS.AES.encrypt(apiKey.toString(), CryptoJS.enc.Utf8.parse(`${process.env.REACT_APP_API_SECRET_KEY}`), {
            keySize: 128 / 8,
            iv: CryptoJS.enc.Utf8.parse(`${process.env.REACT_APP_API_SECRET_KEY}`),
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
        }).toString();
    });
    axios.defaults.headers.common = { key: `${cipher}` };
};
const getData = async (action) => {
    await encryptKey();
    const result = await axios.get(API_URL + action);
    return result;
};
const postData = async (action, data) => {
    await encryptKey();
    const result = await axios.post(API_URL + action, data);
    return result;
};
const putData = async (action, data) => {
    await encryptKey();
    const result = await axios.put(API_URL + action, data);
    return result;
};
const deleteData = async (action) => {
    await encryptKey();
    const result = await axios.delete(API_URL + action);
    return result;
};

const eksportoStream = async (action, gjuha) => {
    await encryptKey();
    return fetch(`${API_URL}Services/${action}?Gjuha=${gjuha}`, {
        method: 'GET',
        headers: { key: cipher },
    });
};

const shikoDokumentin = async (id, signal, nui, emri) => {
    await encryptKey();
    let url = `${API_URL}Services/ShikoDokumentin?id=${encodeURIComponent(id)}`;
    if (nui) url += `&nui=${encodeURIComponent(nui)}`;
    if (emri) url += `&emri=${encodeURIComponent(emri)}`;
    return fetch(url, {
        method: 'GET',
        headers: { key: cipher },
        signal: signal,
    });
};

const eksportoTeGjithaBizneset = (gjuha) => eksportoStream('EksportoBizneset', gjuha);
const eksportoBiznesetShuar = (gjuha) => eksportoStream('EksportoBiznesetShuar', gjuha);
const eksportoBiznesetHuaj = (gjuha) => eksportoStream('EksportoBiznesetHuaj', gjuha);
const eksportoBiznesetFemra = (gjuha) => eksportoStream('EksportoBiznesetFemra', gjuha);

const eksportoTeGjithaBiznesetJson = (gjuha) => eksportoStream('EksportoBiznesetJson', gjuha);
const eksportoBiznesetShuarJson = (gjuha) => eksportoStream('EksportoBiznesetShuarJson', gjuha);
const eksportoBiznesetHuajJson = (gjuha) => eksportoStream('EksportoBiznesetHuajJson', gjuha);
const eksportoBiznesetFemraJson = (gjuha) => eksportoStream('EksportoBiznesetFemraJson', gjuha);

export {
    getData,
    postData,
    putData,
    deleteData,
    shikoDokumentin,
    eksportoTeGjithaBizneset,
    eksportoBiznesetShuar,
    eksportoBiznesetHuaj,
    eksportoBiznesetFemra,
    eksportoTeGjithaBiznesetJson,
    eksportoBiznesetShuarJson,
    eksportoBiznesetHuajJson,
    eksportoBiznesetFemraJson,
};
